export default __webpack_public_path__ + "static/media/wwf_main_mobile_small@2x.68f831b5.jpg";